const src = require("/app/src/assets/images/svg/user.svg?as-resource");
const img = new String(src);
img.src = src;
img.width = 13;
img.height = 16;
img.toString = function() { return src; };
module.exports = img;